import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "edit",
  "use": "edit-usage",
  "viewBox": "0 0 16 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 18\" id=\"edit\">\n    <path fill=\"currentColor\" fill-rule=\"evenodd\" stroke=\"#7D5AA5\" stroke-linejoin=\"round\" stroke-width=\"1.5\" d=\"M14.544 2.92L12.568 1.29a1.277 1.277 0 0 0-1.787.16L1.993 11.878 1 17l4.917-1.891 8.79-10.424a1.244 1.244 0 0 0-.163-1.765z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol